// const API_URL = "http://localhost:3002/api";
// const API_IMAGES =  "http://localhost:3002";
// const API_LOCALHOST =  "http://localhost:8080";

// const API_URL = "http://192.168.11.189:3002/api";
// const API_IMAGES =  "http://192.168.11.189:3002";
// const API_LOCALHOST =  "http://192.168.11.189:8081";

const API_URL = "https://server.smartcard.womi.ma/api";
const API_IMAGES =  "https://server.smartcard.womi.ma";
const API_LOCALHOST =  "https://app.smartcard.womi.ma";

export default{ API_URL , API_IMAGES, API_LOCALHOST };
